module.exports = __webpack_public_path__ + "static/media/catalogue_grid_tile_icon.43d8d0ec.svg";